import React, { FC } from 'react';

import cn from 'classnames';

import css from './UserAvatar.module.scss';

interface UserAvatarProps {
  name: string;
  emailId: string;
  userId: string;
  imgUrl?: string;
  className?: string;
  hasActions?: boolean;
}

export const UserAvatar: FC<UserAvatarProps> = ({
  name,
  userId,
  emailId,
  className,
  imgUrl,
  children,
  hasActions: cellActions = false,
}) => {
  return (
    <div key={userId} className={cn('cell', className)}>
      <div className='cell__user'>
        {imgUrl ? (
          <div style={{ backgroundImage: `url(${imgUrl})` }} className='cell__profile--pic' />
        ) : (
          <div className='cell__profile--letters'>{name ? name[0].toUpperCase() : ''}</div>
        )}
        <div className='cell__details'>
          {name ? <p>{name}</p> : <span className='loader-strip'> &nbsp;</span>}
          <p className='cell__details--email'>{emailId || ''}</p>
        </div>
      </div>
      {cellActions ? <div className='cell__actions'>{children}</div> : null}
    </div>
  );
};

interface EmptyUserAvatarProps {
  message: string;
  title: string;
  className?: string;
}

export const EmptyUserAvatar: FC<EmptyUserAvatarProps> = ({ message, className, title }) => {
  return (
    <div key={message} className={cn('cell', className)}>
      <div className={'cell__user'}>
        <div className={`cell__profile--pic ${css['avatar-block']}`} />
        <div className='cell__details'>
          <p>{title}</p>
          <p className='cell__details--email'>{message}</p>
        </div>
      </div>
    </div>
  );
};

export default UserAvatar;
